// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12122844), 5000);

require("component-responsive-frame/child");
require("waypoints/lib/noframework.waypoints.min");

// document.querySelectorAll(".standalone-img").forEach(image =>{
//     image.onclick = () => {
//         image.classList.toggle("fullsize")
//     }
// })

const triggers = document.querySelectorAll(".text-section"), 
    width = document.getElementById("article").clientWidth,
    window_height = window.innerHeight

// function to hide images
function hideImages() {
    let visible_figures = document.querySelectorAll(".figure-shown"); 

    visible_figures.forEach(function (f) { 
        // Add a delay before adding the "figure-hidden" class
        setTimeout(function() {
            f.classList.remove("figure-shown"); 
            f.classList.add("figure-hidden");
        }, 300); 
    });
}

triggers.forEach(function (t) { 

    new Waypoint({
        element: t,
        offset: function () {
            if (width < 768) {
                // narrow screen
                return window_height - this.element.children[0].clientHeight;
            } else {
                // wide screen
                return 0.5 * window_height;
            }
        },
        handler: function (direction) {
            if (direction === "down") {
                // if text is standalone
                if (t.classList.contains("standalone")) {
                    hideImages();

                // if image is standalone
                } else if (t.classList.contains("standalone-img")) { 
                    hideImages(); 
                
                // if image goes with text
                } else if ((t.classList.contains("left")) && (t.classList.contains("fade"))) { 
                    let step = t.id.split("--")[1],
                        figure_selector = "figure--" + step, 
                        figure = document.getElementById(figure_selector);
                        hideImages(); 
                    
                    figure.classList.remove("figure-hidden"); 
                    figure.classList.add("figure-shown"); 
                
                // if image is final in series of images 
                } else if ((t.classList.contains("left")) && (t.classList.contains("final"))) { 
                    let step = t.id.split("--")[1],
                        figure_selector = "figure--" + step, 
                        figure = document.getElementById(figure_selector);

                        hideImages(); 

                    figure.classList.remove("figure-hidden"); 
                    figure.classList.add("figure-shown"); 
                } 
            }
        },
    });
    new Waypoint({
        element: t,
        offset: function () {
            if (width < 768) {
                // narrow screen
                return -this.element.children[0].clientHeight - 200;
            } else {
                // wide screen
                return -0.50 * window_height;
            }
        },
        handler: function (direction) {
            if (direction === "up") {
                // if text is standalone
                if (t.classList.contains("standalone")) {
                    hideImages();

                // if image is standalone
                } else if (t.classList.contains("standalone-img")) { 
                    hideImages(); 
                
                // if image goes with text
                } else if ((t.classList.contains("left")) && (t.classList.contains("fade"))) { 
                    let step = t.id.split("--")[1],
                        figure_selector = "figure--" + step, 
                        figure = document.getElementById(figure_selector);

                    hideImages(); 
                    figure.classList.remove("figure-hidden"); 
                    figure.classList.add("figure-shown"); 
                    
                } else if ((t.classList.contains("left")) && (t.classList.contains("final"))) { 
                    let step = t.id.split("--")[1],
                        figure_selector = "figure--" + step, 
                        figure = document.getElementById(figure_selector);

                    hideImages(); 
                    figure.classList.remove("figure-hidden"); 
                    figure.classList.add("figure-shown"); 
                    
                } 
            }
        },
    });

    
});


new Waypoint({
    element: document.querySelector("#section--0"), 
    offset: window_height, 
    handler: function (direction) {
        if (direction === "up") {
            //   updateFlightLegend("both");
            hideImages();
        }
    },
});



// function change(e) {
//     e.classList.toggle("fullsize");
// }

// function updateImageOpacity(figure, direction) {
//     const figureRect = figure.getBoundingClientRect();
//     const distanceToTop = figureRect.top;
//     const figureHeight = figureRect.height;
//     const scrollProgress = Math.max(0, Math.min(1, 1 - distanceToTop / figureHeight));

//     figure.querySelectorAll(".article__img").forEach(function (img) {
//         img.style.opacity = scrollProgress;
//     });
// }